<template>
  <button v-enter-to-tab="enterToTab" type="button" class="btn btn--primary justify-content-center" :class="styles"
          @click="$emit('click', $event)" >
    <smtt-icon v-if="layout === 'icon-label' || layout === 'icon'" :icon="icon" class="mr-2" />
    <slot v-if="layout !== 'icon'" />
  </button>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: 'AppButton',
  props: {
    size: {
      type: String,
      required: false,
      default: 'md'
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullHeight: { type: Boolean, required: false, default: false },
    multipleLines: { type: Boolean, required: false, default: false },
    enterToTab: { type: Boolean, required: false, default: false },
    layout: {
      type: String,
      required: false,
      default: '',
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    btnType: {
      type: String,
      required: false,
      default: 'solid'
    },
    modification: {
      type: String,
      required: false,
      default: 'primary'
    }
  },
  data: ()  => {
    return {

    }
  },
  computed: {
    styles() {
      const result = [];

      if(this.enterToTab) {
        result.push('EnterToTab')
      }

      switch (this.modification) {
        case 'grey':
          result.push('btn-grey')
          break
      }

      switch(this.size) {
        case 'md':
          result.push('btn--md');
          break;
        case 'sm':
          result.push('btn--sm');
          break;
        case 'lg':
          result.push('btn--lg');
          break;
        default:
          result.push('btn--md');
          break;
      }

      if (this.fullWidth) {
        result.push('btn--full-width');
      }

      if (this.multipleLines) {
        result.push('flex-column');
      }

      if(this.fullHeight) {
        result.push('btn--full-height');
      }

      switch (this.btnType) {
        case 'outline':
          result.push('btn--outline');
          break;
        case 'solid':
          result.push('btn--solid ');
          break;
        case 'ghost':
          result.push('btn--ghost');
          break;
        default:
          result.push('btn--solid');
          break;
      }

      return result;
    }
  },
  methods: {
    ...mapActions([

    ]),
  },
  created() {

  }
}
</script>

<style scoped>
.btn-grey {
    background-color: #DDDDDD !important;
    color: #4a4a4a !important;
    border-color: #DDDDDD !important;
}

.btn--solid:disabled, .btn--solid:disabled:hover {
  border: 1px solid rgb(204, 204, 204) !important;
  background-color: rgb(245, 245, 245) !important;
  color: rgb(143, 143, 143) !important;
  cursor: not-allowed;
}

.btn-grey:not(:disabled):not(.disabled):hover {
  background-color: #b9b9b9 !important;
  color: #4a4a4a !important;
  border-color: #DDDDDD !important;
}
</style>